import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';

/**
 * Standard di sicurezza dei minori / Child Safety Standards (Google Play).
 * Pagina pubblica, stesso pattern di CommunityRulesPage. Copy in it/en `childSafety.json`.
 */
const SECTION_IDS = [
  'zero_tolerance',
  'user_reports',
  'authorities',
  'platform_protection',
  'adults_only',
  'contacts',
  'updates',
];

const LAST_UPDATED = '2026-09-01';

const ChildSafetyPage = () => {
  const { t } = useTranslation('childSafety');
  const sections = SECTION_IDS.map((id) => ({
    id,
    title: t(`sections.${id}`),
  }));
  const email = t('contact_email');

  return (
    <LegalPageLayout
      namespace="childSafety"
      eyebrow={t('eyebrow')}
      title={t('title')}
      subtitle={t('subtitle')}
      lastUpdated={LAST_UPDATED}
      sections={sections}
      testId="child-safety-page"
    >
      <p className="mb-10 leading-relaxed text-foreground/90" data-testid="child-safety-intro">
        {t('intro')}
      </p>
      {SECTION_IDS.map((id) => (
        <LegalSection
          key={id}
          id={id}
          title={t(`sections.${id}`)}
          body={t(`body.${id}`, { defaultValue: '' })}
          testId={`child-safety-section-${id}`}
        >
          {id === 'contacts' && (
            <p className="mb-4">
              <a
                href={`mailto:${email}`}
                className="font-semibold gold-text underline-offset-4 hover:underline"
                data-testid="child-safety-contact-email"
              >
                {email}
              </a>
            </p>
          )}
          {id === 'updates' && (
            <p className="mt-6 text-xs text-muted-foreground" data-testid="child-safety-last-updated">
              {t('last_updated_line')}
            </p>
          )}
        </LegalSection>
      ))}
    </LegalPageLayout>
  );
};

export default ChildSafetyPage;
